type CreateProjectPortfolioError = {
  portfolioNameIsEmpty: boolean;
  portfolioNameIsNotUnique: boolean;
};

const createProjectPortfolioError: CreateProjectPortfolioError = {
  portfolioNameIsEmpty: false,
  portfolioNameIsNotUnique: false,
};

export type { CreateProjectPortfolioError };

export { createProjectPortfolioError };
